import React, { useState, useEffect } from 'react'

import '../../sytles/button.scss'

const BingoSquareL = () => {
    const [clicked, setClicked ] = useState(window.localStorage.getItem('toggleBtnHandler12') === 'true')

    useEffect(() => {
      window.localStorage.setItem('toggleBtnHandler12', clicked)
    }, [clicked]);

    const toggleBtnHandler = () => {
      setClicked(!clicked)
    }  

     {
      const styles = ['button']
      let text = 'Sceptre!'
      let bodyEl = document.body
      bodyEl.style.background = '#1f1f1f'
      
      if (clicked) {
        styles.push('clicked')
        text = 'Sceptre!';
        bodyEl.style.background = '#EEE'
      } 
      return (
     <div className={`main ${clicked ? "toggleBtnHandler": ''}`}>
        <div className={BingoSquareL}>
            <button className={styles.join(' ')} onClick={toggleBtnHandler}>{text}</button>
        </div>
     </div>
      )
    }
  }

  export default BingoSquareL
  
